import { createQueryKeys } from '@lukemorales/query-key-factory';

import { QueryStringParamsType } from '../queries';
import {
  checkFeatureAccess,
  disableUser,
  getAllRoles,
  getAmbassadors,
  getAuthenticatedUser,
  getAuthUserMailingPreferences,
  getAuthUserTotalHookups,
  getExperts,
  getPublicAmbassadors,
  getPublicExperts,
  getTopActiveMembers,
  getUserDetailByUsernameOrFullName,
  getUserOrganizations,
  getUsersPaginated,
  getUserSubscriptionFeatures,
  getUserSubscriptionStatus
} from '../query-fn';

export const UserQueryStore = createQueryKeys('user', {
  authenticated: {
    queryKey: null,
    queryFn: (ctx) => getAuthenticatedUser(ctx)
  },
  'auth-user-total-hookups': {
    queryKey: null,
    queryFn: (ctx) => getAuthUserTotalHookups(ctx)
  },
  'auth-user-top-active-members': {
    queryKey: null,
    queryFn: (ctx) => getTopActiveMembers(ctx)
  },
  'auth-user-mailing-preferences': {
    queryKey: null,
    queryFn: (ctx) => getAuthUserMailingPreferences(ctx)
  },
  'details-by-username-or-fullname': (key: string) => ({
    queryKey: [key],
    queryFn: (ctx) => getUserDetailByUsernameOrFullName({ ...ctx, params: { key } })
  }),
  paginated: (params: QueryStringParamsType<{ f_fullName: string | undefined; f_username?: string }>) => ({
    queryKey: [params],
    queryFn: (ctx) => getUsersPaginated(params, ctx)
  }),
  organizations: {
    queryKey: null,
    queryFn: (ctx) => getUserOrganizations(ctx)
  },
  ambassadors: {
    queryKey: null,
    queryFn: (ctx) => getAmbassadors(ctx)
  },
  'public-ambassadors': {
    queryKey: null,
    queryFn: (ctx) => getPublicAmbassadors(ctx)
  },
  experts: {
    queryKey: null,
    queryFn: (ctx) => getExperts(ctx)
  },
  'public-experts': {
    queryKey: null,
    queryFn: (ctx) => getPublicExperts(ctx)
  },
  'all-roles': {
    queryKey: null,
    queryFn: (ctx) => getAllRoles(ctx)
  },
  disable: (uuid: string) => ({
    queryKey: [uuid],
    queryFn: (ctx) => disableUser(uuid, ctx)
  }),
  // Subscription-related query store entries
  'subscription-status': {
    queryKey: null,
    queryFn: (ctx) => getUserSubscriptionStatus(ctx)
  },
  'subscription-features': {
    queryKey: null,
    queryFn: (ctx) => getUserSubscriptionFeatures(ctx)
  },
  'feature-access': (feature: string) => ({
    queryKey: [feature],
    queryFn: (ctx) => checkFeatureAccess(ctx, feature)
  })
});
